<!-- 头部 -->
<template>
  <div>
    <!-- 正常导航栏 -->
    <el-row class="defaultNav" type="flex" justify="center">
      <el-col :xs="0" :sm="0" :md="2" :lg="2" :xl="2"></el-col>
      <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
        <div class="header-container">
          <div class="logoArea">
            <router-link :to="{name:'index',params:{showPoster:'false'}}">
              <!-- <img src="../assets/img/index/logo.png"> -->
              <div style="
              font-size: 3vw;
              color: white;
              font-family: Cambria;
              font-style: italic;
              text-shadow: 0.15vw 0.15vw 0.15vw black;
              display: flex;
              justify-content: space-between;
              margin-bottom: 0.2vw;
              ">
                <span v-for="item in 'Wang Lab'">
                  {{item}}
                </span>
              </div>

              <div style="
              font-size: 0.6vw;
              font-family: Cambria;
              font-style: italic;
              color: white;
              display: flex;
              justify-content: space-between;
              margin-bottom: 0.5vw;
              "
              >
                <span v-for="item in 'Micro/nano Fluidic Analysis'">
                  {{item}}
                </span>

              </div>

              <div style="
              color: white;
              font-size: 1.4vw;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              text-shadow: 0.15vw 0.15vw 0.15vw black;
              ">
                <!-- <h2>微纳流空分析</h2> -->
                <span v-for="item in '微纳流控分析'">
                  {{item}}
                </span>
              </div>
            </router-link>
          </div>
          <div class="menuArea">
            <ul class="menu">
              <li class="menu-item">
                <router-link :to="{path:'/'}" style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">Home</router-link>
              </li>
              <li class="menu-item">
                <router-link :to="{path:'/intr'}" style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">Prof. Wang</router-link>
              </li>
              <li class="menu-item" @mouseover="showSubmenu2" @mouseout="hiddenSubmenu2">
                <span style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">
                  Members
                </span>
                <el-collapse-transition>
                  <ul class="submenu submenu2" v-show="showSub2" style="">
                    <li class="submenu-item" v-for="(e,index) in memberlist" :key="index">
                      <router-link :to="{path:'/memberdetail',query:{id:e.id}}">{{e.name}}</router-link>
                    </li>
                  </ul>
                </el-collapse-transition>

              </li>

              <li class="menu-item" >
                <!-- <router-link :to="{path:'/memberdetail',query:{id:e.id}}">{{e.name}}</router-link> -->
                <router-link :to="{path:'/literature'}" style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">Publication</router-link>
              </li>

              <!-- <li class="menu-item" @mouseover="showSubmenu3" @mouseout="hiddenSubmenu3">
                <span style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">
                  Publication
                </span>
                <el-collapse-transition>
                  <ul class="submenu submenu3" v-show="showSub3">
                    <li class="submenu-item">
                      <router-link :to="{path:'/dynamiclist'}">交流动态</router-link>
                    </li>
                    <li class="submenu-item" @mouseover="showThirdmenu" @mouseout="hiddenThirdmenu">
                      <span>
                        <router-link :to="{path:'/literature'}">资料下载</router-link>
                      </span>
                    </li>
                  </ul>
                </el-collapse-transition>
              </li> -->
              <li class="menu-item">
                <router-link :to="{path:'/newslist'}" style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">News</router-link>
              </li>
              <li class="menu-item">
                <router-link :to="{path:'/join'}" style="color: white;text-shadow: 0.05vw 0.05vw 0.05vw black;">Contact</router-link>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :xs="0" :sm="0" :md="2" :lg="2" :xl="2"></el-col>
    </el-row>

    <!-- 缩略导航栏 -->
    <div class="mini-menu">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 1vw;
          padding-right: 1vw;
          ">
            <!-- logo -->
            <!-- <div>
              <router-link :to="{name:'index',params:{showPoster:'false'}}">
                <img class="mini-logo" src="../assets/img/index/minilogo.png">
              </router-link>
            </div> -->
            <div style="
            font-size: 6vw;
            color: #85b1e0;
            font-family: Cambria;
            font-style: italic;
            text-shadow: 0.15vw 0.15vw 0.15vw black;
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.2vw;
            ">
              <span v-for="item in 'Wang Lab'">
                {{item}}
              </span>
            </div>
            <!-- 导航按钮 -->
            <div class="mini-menu-btn el-icon-s-grid" @click="showMiniNav"></div>
          </div>


          <el-collapse-transition>
            <div class="mini-menu-nav" v-show="miniNav">
              <el-row type="flex" justify="center">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div>
                    <el-menu :class="'mini-menu-nav-dropdown'" :default-active="this.$route.path" router class="el-menu-demo"
                      mode="vertical" @select="handleSelect">
                      <el-menu-item index="/">Home</el-menu-item>
                      <el-menu-item index="/intr">Prof. Wang</el-menu-item>


                      <el-submenu index='2'>
                        <template slot="title">
                          <p class="subTitle">Members</p>
                        </template>
                        <el-menu-item class="memberdetail-item" v-for="(e,index) in memberlist" :key="index" @click="goSub3(e.id)">
                          <!-- <router-link :to="{path:'/memberdetail',query:{id:e.id}}">{{e.name}}</router-link> -->
                          <a>{{e.name}}</a>
                        </el-menu-item>
                      </el-submenu>

                      <el-menu-item index="/literature">Publication</el-menu-item>


                      <!-- <el-submenu index='3'>
                        <template slot="title">
                          <p class="subTitle">资料下载</p>
                        </template>
                        <el-menu-item class="memberdetail-item" v-for="(e,index) in lirTypeList" :key="index" @click="goLir(e.id)">
                          <a>{{e.type}}</a>
                        </el-menu-item>
                      </el-submenu> -->
                      <el-menu-item index="/newslist">News</el-menu-item>
                      <el-menu-item index="/join">Contact</el-menu-item>
                    </el-menu>
                  </div>
                </el-col>
              </el-row>
              <div class="mini-menu-nav-back el-icon-caret-top" @click="closeMiniNav">
              </div>
            </div>
          </el-collapse-transition>

        </el-col>
      </el-row>
    </div>





  </div>
</template>

<script>
  export default {
    data() {
      return {
        showSub1: false,
        showSub2: false,
        showSub3: false,
        showThirdItem: false,
        memberlist: '',
        organizationList: [],
        lirTypeList:[],

        // 缩略导航
        miniNav: false,


      };
    },

    components: {},

    mounted() {
      this.getMemberList();
      this.getOrganizationList();
      this.getLirTypeList();

    },



    methods: {

      // 缩略导航
      showMiniNav() {
        if (this.miniNav == true) {
          this.miniNav = false
        } else if (this.miniNav == false) {
          this.miniNav = true
        }
      },

      // 单独关闭缩略导航
      closeMiniNav() {
        this.miniNav = false
      },

      goSub3(id) {
        this.$router.push({
          path: '/memberdetail',
          query: {
            id: id
          }
        });
        this.miniNav = false
      },

      goOrg(id) {
        this.$router.push({
          path: '/organization',
          query: {
            id: id
          }
        });
        this.miniNav = false
      },

      goLir(id)
      {
        this.$router.push({
          path: '/literature',
          query: {
            id: id
          }
        });
        this.miniNav = false
      },



      // 普通导航
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      showSubmenu1() {
        this.showSub1 = true;
      },
      hiddenSubmenu1() {
        this.showSub1 = false;
      },
      showSubmenu2() {
        this.showSub2 = true;
      },
      hiddenSubmenu2() {
        this.showSub2 = false;
      },
      showSubmenu3() {
        this.showSub3 = true;
      },
      hiddenSubmenu3() {
        this.showSub3 = false;
      },
      showThirdmenu() {
        this.showThirdItem = true;
      },
      hiddenThirdmenu() {
        this.showThirdItem = false;
      },

      // 获取组织机构列表
      getOrganizationList() {
        this.instance.get('/api/organization/getlist').then(res => {
          if (res.status == 200) {
            this.organizationList = res.data.organization_list
          }
        })
      },

      getLirTypeList()
      {
        this.instance.get('/api/data/gettypelist').then(res=>{
          if (res.status == 200) {
            this.lirTypeList = res.data.typelist
          }
        })
      },

      // 获取成员列表
      getMemberList() {
        this.instance.get('/api/memberlist').then(res => {
          if (res.status == 200) {
            this.memberlist = res.data.memberlist;
          }
        })
      },


    }
  }
</script>
<style scoped>

  .defaultNav {
    /* background-color: red; */
    background-image: url('../assets/img/index/wangtopbg.jpg');
    background-size: cover;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }


  /* 新闻菜单滚动 */
  .news-item {
    height: 31.25rem;
    overflow: auto;
  }

  .header-container {
    width: 100%;
    margin: 1vw auto 1vw auto;
    /* background-color: red; */
  }

  /* logo区域 */
  .header-container .logoArea {
    /* 比例7:5 */
    width: 17.5%;
    margin-right: 16%;
    text-align: center;
    display: inline-block;
    /* border: 1px solid red; */
    /* background-color: greenyellow; */
  }

  .header-container .logoArea>a>img {
    /* width: 250px; */
    width: 100%;
  }

  .header-container .logoArea>a>div>h2 {
    color: #404040;
    font-size: 1.2vw;
  }

  .header-container .logoArea>a>div>h4>span {
    color: #8497B0;
    display: inline-block;
  }

  .header-container .logoArea>a>div>h4>span::first-letter {
    color: #F6BB00;
  }

  /* munu区域 */
  .header-container .menuArea {
    width: 65.75%;
    display: inline-block;
    vertical-align: bottom;
    /* background-color: burlywood; */
  }

  .header-container .menuArea>.menu {
    text-align: right;
    list-style: none;
  }

  .header-container .menu>.menu-item {
    width: 13%;
    height: 100%;
    line-height: 2vw;
    margin-left: 1.5vw;
    color: #3C4A5D;
    font-size: 1vw;
    text-align: center;
    position: relative;
    display: inline-block;
    /* background-color: coral; */
  }

  .header-container .menu>.menu-item a{
    display: block;
    height: 100%;
    /* color: #3C4A5D; */
    color: black;
    /* color: white; */
    /* text-shadow: 0.05vw 0.05vw 0.05vw black; */
  }
  .header-container .menu>.menu-item span {
    display: block;
    height: 100%;
    /* color: #3C4A5D; */
    /* color: black; */
    color: white;
    /* text-shadow: 0.05vw 0.05vw 0.05vw black; */
  }

  .header-container .menu>.menu-item>a,
  .header-container .menu>.menu-item>span {
    width: 100%;
    font-weight: bold;
    border-bottom: 0.2vw solid #FFC000;
  }

  .header-container .menu>.menu-item a:hover,
  .header-container .menu>.menu-item span:hover {
    color: #A6A6A6;
    cursor: pointer;
    background-color: #FEE8A6;
  }

  /* 二级导航 */
  .header-container .menu-item>.submenu {
    position: absolute;
    list-style: none;
    text-align: left;
    z-index: 10;
    margin-top: 0.5vw;
    /* padding-top: 1vw; */
    height: auto;
    /* background-color: firebrick; */
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 2px rgba(0, 0, 0, .04);
  }


  .header-container .submenu>li {}


  .header-container .submenu>.submenu-item>a,
  .header-container .submenu>.submenu-item>span {
    background-color: rgb(255, 255, 255);
    padding-left: 0.5vw;
    font-size: 0.8vw;
  }


  .header-container .menu-item>.submenu1 {
    min-width: 100%;
  }

  .header-container .menu-item>.submenu2 {
    width: 28vw;
    min-width: 100%;
  }

  .header-container .menu-item>.submenu3 {
    min-width: 100%;
  }

  /* 三级菜单 */
  .header-container .menu-item .thirdmenu {
    background-color: rgb(255, 255, 255);
    position: absolute;
    list-style: none;
    width: 100%;
    z-index: 10;
    top: 3vw;
    left: 100%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .header-container .thirdmenu-item>a {
    padding-left: 0.5vw;
    font-size: 0.8vw;

  }


  /* 缩略导航 */
  .mini-menu {
    position: fixed;
    z-index: 10;
    width: 100%;
    /* height: 5vw; */
    background-color: #FDFDFE;
    border-bottom: 0.1vw solid #D7E2EE;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .mini-menu .mini-logo {
    float: left;
    height: 5vw;
    display: inline-block
  }

  .mini-menu .mini-menu-btn {
    float: right;
    left: calc(100% - 5vw);
    /* background-color: #FEE8A6; */
    font-size: 5vw;
    color: #9DB7D6;
    display: inline-block
  }

  .mini-menu-btn:active {
    color: #6495ED;
  }

  .mini-menu-nav {
    position: absolute;
    top: 5.1vw;
    width: 100%;
    z-index: 10;
    height: auto;
    font-weight: bold;
    /* color: #3C4A5D; */
    /* background-color: red; */
    overflow: auto;
  }

  .mini-menu-nav-dropdown {
    height: auto;
    max-height: 80vh;
    overflow: auto;
    /* background-color: red; */
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 2px rgba(0, 0, 0, .04);
  }

  .mini-menu-nav-back {
    position: relative;
    left: 50%;
    margin-left: -9%;
    height: auto;
    text-align: center;
    font-size: 2.5vw;
    width: 18%;
    background-color: white;
    filter: 6px;
    border-radius: 0 0 20px 20px;
    border: 1px solid #D7E2EE;
    margin-bottom: 0.1vw;
    color: #9DB7D6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 2px rgba(0, 0, 0, .04);
  }

  .mini-menu-nav-back:active {
    color: white;
    background-color: #6495ED;
    border: 0;
  }

  .memberdetail-item {
    width: 100%;
    /* background-color: #2C90FF; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .memberdetail-item:hover {
    overflow: auto;
    text-overflow: clip;
  }


  .memberdetail-item a {
    color: #3C4A5D;
  }

  /* .mini-menu>>>{
    width: 100%;
    word-break: break-all;
  } */
  /* class="el-menu-item is-active" */


  @media screen and (min-width:1200px) {
    .mini-menu {
      display: none;
    }
  }

  @media screen and (max-width:1200px) {
    .defaultNav {
      display: none;
    }
  }

  @media screen and (min-width:992px) and (max-width:1200px) {}

  @media screen and (min-width:768px) and (max-width:992px) {
    .mini-menu .mini-logo {
      height: 7vw;
    }

    .mini-menu .mini-menu-btn {
      font-size: 7vw;
    }

    .mini-menu-nav {
      top: 7.1vw;
    }
  }

  @media screen and (min-width:500px) and (max-width:768px) {
    .mini-menu .mini-logo {
      height: 9vw;
    }

    .mini-menu .mini-menu-btn {
      font-size: 9vw;
    }

    .mini-menu-nav {
      top: 9.1vw;
    }

    .mini-menu-nav-back {
      font-size: 3.6vw;
      width: 30%;
      margin-left: -15%;
      border-radius: 0 0 15px 15px;
    }
  }

  @media screen and (max-width:500px) {
    .mini-menu .mini-logo {
      height: 11vw;
    }

    .mini-menu .mini-menu-btn {
      font-size: 11vw;
    }

    .mini-menu-nav {
      top: 11.1vw;
    }

    .mini-menu-nav-back {
      font-size: 5.6vw;
      width: 30%;
      margin-left: -15%;
      border-radius: 0 0 15px 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue